import { Component, OnInit, Input, forwardRef, NgModule, TemplateRef, Output, EventEmitter, ViewChild, ViewContainerRef, ElementRef, ContentChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule, NgForOfContext } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { API } from '../services/api';
import { Subject } from 'rxjs/Rx';

export interface Shipper {
    name: string;
    id?: string;
    idBak?: string;
    mobile?: string;
    disabled?: boolean;
}

export interface DomOpt {
    _value: string;
    _label: string;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ShipperSelectComponent),
    multi: true
};
export class ShipperSelectComponent implements ControlValueAccessor, OnInit {

     domOpt: DomOpt;
private onTouchedCallback: () => () => {};
private onChangeCallback: (_: any) => () => {};

    options: Array<Shipper> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _content: TemplateRef<any>;
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    currentText = '';
    canQuery = true;
    keyWordStream = new Subject<string>()
    keyWord$: any;

     placeholder = "请输入发货人";
     valueType = "";
/**
 * @param {?} v
 * @return {?}
 */
set value(v: string) {
        if(typeof v === 'string' && v.trim() === '' || !v) {
            this.options = [];
            this.currentText = '';
            this.queryData('', []);
        }
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            const { _value, _label } = this.domOpt;
            this.onChangeCallback({ value: _value, label: _label });
        } else {
            this.onChangeCallback(v);
        }

    }
/**
 * @return {?}
 */
get value(): string {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} v
 * @return {?}
 */
set OptionMode(v) {
        this._nzMode = v;
        this._allowClear = v === "combobox" ? true : false;
    };
/**
 * @param {?} tpl
 * @return {?}
 */
set customTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._content = tpl;
        }
    }

     openChange: EventEmitter<any> = new EventEmitter();
     outOptions: EventEmitter<any> = new EventEmitter();
/**
 * @param {?} api
 */
constructor(private api: API) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, [])
            });

    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.keyWordStream.next(event);
    }
/**
 * 仅作清空多选选项
 * @param {?=} $event
 * @return {?}
 */
clearSelect($event?: MouseEvent): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.options = [];
        this.value = '';
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @return {?}
 */
queryData(searchText?: string, options?: Array<Shipper>) {
        if (!this.canQuery) return;
        const /** @type {?} */ value = searchText;
        this.api.call("customerWorkerController.queryShipperNameLike",{
            name: value,
            clientType:"send"
        }).ok(json => {
            const /** @type {?} */ result = json.result || [];
            this.options = result;
            this.outOptions.emit(this.options);
        }).fail(err => {
            if (!this.options.length) {
                const /** @type {?} */ lastItem = new Array<Shipper>({ id: "empty", name: "没有更多选项！", disabled: true });
                this.options = options.concat(lastItem);
                this.canQuery = false;
                return;
            }
            throw new Error(err);
        });
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-shipper`,
    template: `
    <div class="shipper-select">
        <nz-select 
            class="shipper-nz-select"
            [style.width]="_width" 
            [nzPlaceHolder]="placeholder" 
            [nzMode]="_nzMode"
            [nzFilter]="_filter"
            [nzAllowClear]="_allowClear"
            (nzSearchChange)="yztSearchChange($event)"
            [(ngModel)]="value">
            <nz-option
                #domOpt
                *ngFor="let option of options"
                [nzLabel]="option.name"
                [nzValue]="option.idBak"
                [nzDisabled]="option.disabled">
                <ng-template *ngIf="_content" #nzOptionTemplate>
                    <ng-container #nzOptionCon [ngTemplateOutlet]="_content" [ngTemplateOutletContext]="option"></ng-container>
                </ng-template>
            </nz-option>
        </nz-select>
        <span
          role="close-icon"
          (click)="clearSelect($event)"
          class="ant-select-selection__clear close-icon"
          style="-webkit-user-select: none;"
          *ngIf="!_allowClear&&options.length">
        </span>
    </div>
    `,
    styles: [`
    .shipper-select{
        position: relative;
    }
    .close-icon {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -10px;
    }
    .close-icon:hover {
        opacity: 1;
    }
    .shipper-nz-select:hover +.close-icon {
        opacity: 1;
    }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'domOpt': [{ type: ViewChild, args: ["domOpt", ] },],
'placeholder': [{ type: Input },],
'valueType': [{ type: Input },],
'width': [{ type: Input },],
'OptionMode': [{ type: Input },],
'customTemplate': [{ type: Input },],
'openChange': [{ type: Output },],
'outOptions': [{ type: Output },],
};
}

function ShipperSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
ShipperSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShipperSelectComponent.ctorParameters;
/** @type {?} */
ShipperSelectComponent.propDecorators;
/** @type {?} */
ShipperSelectComponent.prototype.domOpt;
/** @type {?} */
ShipperSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
ShipperSelectComponent.prototype.onChangeCallback;
/** @type {?} */
ShipperSelectComponent.prototype.options;
/** @type {?} */
ShipperSelectComponent.prototype._value;
/** @type {?} */
ShipperSelectComponent.prototype._width;
/** @type {?} */
ShipperSelectComponent.prototype._content;
/** @type {?} */
ShipperSelectComponent.prototype._allowClear;
/** @type {?} */
ShipperSelectComponent.prototype._nzMode;
/** @type {?} */
ShipperSelectComponent.prototype._filter;
/** @type {?} */
ShipperSelectComponent.prototype.currentText;
/** @type {?} */
ShipperSelectComponent.prototype.canQuery;
/** @type {?} */
ShipperSelectComponent.prototype.keyWordStream;
/** @type {?} */
ShipperSelectComponent.prototype.keyWord$;
/** @type {?} */
ShipperSelectComponent.prototype.placeholder;
/** @type {?} */
ShipperSelectComponent.prototype.valueType;
/** @type {?} */
ShipperSelectComponent.prototype.openChange;
/** @type {?} */
ShipperSelectComponent.prototype.outOptions;
/** @type {?} */
ShipperSelectComponent.prototype.api;
}

export class ShipperSelectModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
    ],
    declarations: [
        ShipperSelectComponent
    ],
    exports: [ShipperSelectComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ShipperSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
ShipperSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShipperSelectModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
